import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SesionSelectorSharedLocalStateI {
	[key: string]: { label: number; value: string };
}

const initialState: SesionSelectorSharedLocalStateI = null as any;

const sesionSelectorSharedLocalStateSlice = createSlice({
	name: 'sesionSelectorSharedLocalState',
	initialState,
	reducers: {
		setSesionSelectorSharedLocalState: (state, action: PayloadAction<SesionSelectorSharedLocalStateI>) => {
			return action.payload;
		},
		updateSesionSelectorSharedLocalState: (state, action: PayloadAction<SesionSelectorSharedLocalStateI>) => {
			const newValue = action.payload;
			return { ...state, ...newValue };
		},
		resetSesionSelectorSharedLocalState: () => {
			return initialState;
		}
	}
});

export const {
	setSesionSelectorSharedLocalState,
	resetSesionSelectorSharedLocalState,
	updateSesionSelectorSharedLocalState
} = sesionSelectorSharedLocalStateSlice.actions;

export default sesionSelectorSharedLocalStateSlice.reducer;
